/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizersaved1Inputs */

const en_organizersaved1 = /** @type {(inputs: Organizersaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const de_organizersaved1 = /** @type {(inputs: Organizersaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Organizersaved1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizersaved1 = /** @type {((inputs?: Organizersaved1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizersaved1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizersaved1(inputs)
	return de_organizersaved1(inputs)
});
export { organizersaved1 as "organizerSaved" }